export const FileSystemEvents = {
	fileSystemLocationChanged: 'file-system-location-changed',
	fileSystemObjectMoved: 'file-system-object-moved',
};

export const FileManagerEvents = {
	fileManagerMounted: 'file-manager-mounted',
	fileSystemObjectClicked: 'file-system-object-clicked'
};

export const InputDialogEvents = {
	inputConfirmed: 'input-confirmed',
	inputCanceled: 'input-canceled'
};

export const ResizeDialogEvents = {
	resizeConfirmed: 'resize-confirmed',
	resizeCanceled: 'resize-canceled'
};